import axiosInstance from "../axios/axiosInstance";
import ENV from "constants/env";

const cid = () => localStorage.getItem("companyId") || ENV.COMPANY_ID;
const unwrap = (res) => Array.isArray(res) ? res : (res?.data ?? res?.items ?? []);

export const getDepartments = async () => unwrap((await axiosInstance.get(`/companies/${cid()}/departments`)).data);
export const createDepartment = async (p) => (await axiosInstance.post(`/companies/${cid()}/departments`, p)).data;
export const updateDepartment = async ({departmentId, ...p}) => (await axiosInstance.patch(`/companies/${cid()}/departments/${departmentId}`, p)).data;
export const deleteDepartment = async (id) => (await axiosInstance.delete(`/companies/${cid()}/departments/${id}`)).data;
